// export function formatDateTime(dateString) {
//   const date = new Date(dateString);

//   const options = {
//     year: "numeric",
//     month: "short", 
//     day: "2-digit",
//     hour: "2-digit",
//     minute: "2-digit",
//     second: "2-digit",
//     hour12: true, 
//   };

//   return date.toLocaleString("en-US", options);
// }

export const formatDateTime = (d) => {
  const date = new Date(d);
  const [day, month, year] = [date.getDate(), date.getMonth() + 1, date.getFullYear()];
  let [hrs, mins, secs] = [date.getHours(), date.getMinutes(), date.getSeconds()];
  const ampm = hrs >= 12 ? "PM" : "AM";
  hrs = hrs % 12 || 12;
  return `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year} ${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')} ${ampm}`;
};
export const formatSessionTime = (seconds) => {
  if (!seconds || isNaN(seconds)) return "--";

  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;

  const hours = h > 0 ? `${h}h ` : "";
  const minutes = m > 0 ? `${m}m ` : "";
  const secs = `${s}s`;

  return `${hours}${minutes}${secs}`.trim();
};
